import { ChangeDetectorRef, Component, Input, SimpleChanges, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NbDialogService } from '@nebular/theme';
import { ColDef } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { AddNotesModalComponent } from '../Modalla-Popup/add-notes-modal/add-notes-modal.component';
import { ConfirmApprovalModalComponent } from '../Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { ConfirmRejectionModalComponent } from '../Modalla-Popup/confirm-rejection-modal/confirm-rejection-modal.component';
import { ConfirmSendToFirstAidModalComponent } from '../Modalla-Popup/confirm-send-to-first-aid-modal/confirm-send-to-first-aid-modal.component';
import { FormApprovalSuccessModalComponent } from '../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { FormRejectionSuccessModalComponent } from '../Modalla-Popup/form-rejection-success-modal/form-rejection-success-modal.component';
import { ResolvedByFirstAidModalComponent } from '../Modalla-Popup/resolved-by-first-aid-modal/resolved-by-first-aid-modal.component';
import { NotesAddedSucesfulModalComponent } from '../Modalla-Popup/notes-added-sucesful-modal/notes-added-sucesful-modal.component';
import { AppAocCocMappingModalComponent } from '../Modalla-Popup/app-aoc-coc-mapping-modal/app-aoc-coc-mapping-modal.component';
import { ConfirmSendBackToApplicantModalComponent } from '../Modalla-Popup/confirm-send-back-to-applicant-modal/confirm-send-back-to-applicant-modal.component';
import { ConfirmForwardToGAOModalComponent } from '../Modalla-Popup/confirm-forward-to-gao-modal/confirm-forward-to-gao-modal.component';
import { environment } from 'src/environments/environment';
import { GridPermissionByRole } from 'src/Core/Models/grid-permission-by-role.model';

@Component({
  selector: 'app-application-list-grid',
  templateUrl: './application-list-grid.component.html',
  styleUrls: ['./application-list-grid.component.scss']
})
export class ApplicationListGridComponent implements OnDestroy {

  @Input() gridPermissionByRole!: GridPermissionByRole
  @Input() columnDefs: ColDef[] | null = null;  // Optional override from parent
  @Input() showActionColumn: boolean = true;    // Control showing action column from parent
  @Input() gridData: any[] = [];                // Allow parent to directly bind data

  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment

  themeClass = 'ag-theme-quartz';
  paginationPageSize = 10;
  paginationPageSizeSelector = [10, 25, 50, 100];
  gridOptions = { pagination: true, paginationPageSize: this.paginationPageSize };
  public defaultColDef: ColDef = { filter: "agTextColumnFilter", floatingFilter: true, sortable: true };
  currentPage = 1; // Current page
  totalPages = 1;  // Total number of pages
  // gridData: any[] = []; // Now handled via @Input

  // Image preview properties
  showPreview = false;
  previewImageUrl = '';
  previewPosition = { x: 0, y: 0 };
  private hidePreviewTimeout: any;
  private currentImageElement: HTMLImageElement | null = null;
  private mouseMoveListener!: (event: MouseEvent) => void;


  constructor(private cd: ChangeDetectorRef,private api: SevaProfileService, private dialogService: NbDialogService, private toastr: ToastrService, private router: Router, private route: ActivatedRoute, private location: Location
  ) { }

  ngOnInit() { 
    // Initialize pagination from URL parameters
    this.initializeFromUrl();
    
    // Add global mouse move listener to detect when mouse leaves image area
    this.mouseMoveListener = (event: MouseEvent) => {
      if (this.showPreview && this.currentImageElement) {
        // Check if mouse is not over the image or preview
        const isOverImage = this.currentImageElement.contains(event.target as Node);
        const previewElement = document.querySelector('.image-preview-popup');
        const isOverPreview = previewElement?.contains(event.target as Node);
        
        if (!isOverImage && !isOverPreview) {
          this.hideImagePreview();
        }
      }
    };
    
    document.addEventListener('mousemove', this.mouseMoveListener);
  }

  // Initialize pagination and filters from URL parameters
  private initializeFromUrl(): void {
    const queryParams = this.route.snapshot.queryParams;
    
    // Set current page from URL
    if (queryParams['page']) {
      this.currentPage = parseInt(queryParams['page']) || 1;
    }
    
    // Set page size from URL
    if (queryParams['pageSize']) {
      this.paginationPageSize = parseInt(queryParams['pageSize']) || 10;
      this.gridOptions.paginationPageSize = this.paginationPageSize;
    }
    
    // If we have URL parameters, trigger data fetch
    if (queryParams['page'] || queryParams['pageSize'] || this.hasFilterParams()) {
      console.log('URL parameters detected, fetching data...');
      this.getApplicantData(this.currentPage, true);
    }
  }
  
  // Helper method to check if there are filter parameters in URL
  private hasFilterParams(): boolean {
    const queryParams = this.route.snapshot.queryParams;
    const filterKeys = ['DistrictId', 'StateId', 'CenterId', 'Status', 'ApplicationType', 'DateFrom', 'DateTo'];
    return filterKeys.some(key => queryParams[key]);
  }

  // Method to get filter parameters from URL
  private getFilterParamsFromUrl(): string {
    const queryParams = this.route.snapshot.queryParams;
    const filterParams: string[] = [];
    
    // Add default filter if configured
    if (this.gridPermissionByRole?.defaultFilter) {
      filterParams.push(`filter=${encodeURIComponent(this.gridPermissionByRole.defaultFilter)}`);
    }
    
    // Add common filter parameters that should be preserved
    const filterKeys = ['DistrictId', 'StateId', 'CenterId', 'Status', 'ApplicationType', 'DateFrom', 'DateTo'];
    
    filterKeys.forEach(key => {
      if (queryParams[key]) {
        filterParams.push(`${key}=${queryParams[key]}`);
      }
    });
    
    return filterParams.length > 0 ? '&' + filterParams.join('&') : '';
  }

  // Public method to update URL with filter parameters (can be called from parent)
  public updateUrlWithFilters(filterParams: any): void {
    console.log('updateUrlWithFilters called with:', filterParams);
    
    const queryParams = { ...this.route.snapshot.queryParams };
    
    // Update query parameters with new filter values
    Object.keys(filterParams).forEach(key => {
      if (filterParams[key] !== null && filterParams[key] !== undefined && filterParams[key] !== '') {
        queryParams[key] = filterParams[key];
      } else {
        // Remove parameter if it's empty
        delete queryParams[key];
      }
    });
    
    // Reset to first page when filters change
    queryParams['page'] = '1';
    this.currentPage = 1;
    
    console.log('Updated queryParams:', queryParams);
    
    // Update URL without reloading the page
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
    
    // Call API directly with filter parameters instead of relying on URL
    console.log('Calling getApplicantDataWithFilters...');
    this.getApplicantDataWithFilters(this.currentPage, filterParams, true);
  }
  
  // Method to get applicant data with specific filter parameters
  private getApplicantDataWithFilters(page: number, filterParams: any, forceUpdate: boolean = false): void {
    const size = this.paginationPageSize;
    const validPage = Math.max(1, page);
    const start = (validPage - 1) * size;
    
    // Update component state
    this.currentPage = validPage;
    this.paginationPageSize = size;
    this.gridOptions.paginationPageSize = size;
    
    // Build filter parameters string
    const filterParamsArray: string[] = [];
    
    // Add default filter if configured
    if (this.gridPermissionByRole?.defaultFilter) {
      filterParamsArray.push(`filter=${encodeURIComponent(this.gridPermissionByRole.defaultFilter)}`);
    }
    
    // Add other filter parameters
    Object.keys(filterParams)
      .filter(key => filterParams[key] !== null && filterParams[key] !== undefined && filterParams[key] !== '')
      .forEach(key => {
        filterParamsArray.push(`${key}=${filterParams[key]}`);
      });
    
    const filterParamsString = filterParamsArray.join('&');
    
    const apiUrl = `${this.gridPermissionByRole.getApplicationListUrlEndPoint}?start=${start}&size=${size}&sortBy=CreatedOn&sortDir=desc${filterParamsString ? '&' + filterParamsString : ''}`;
    
    console.log('Filter API Debug:', {
      validPage: validPage,
      size: size,
      start: start,
      filterParams: filterParams,
      filterParamsString: filterParamsString,
      apiUrl: apiUrl
    });
    
    this.api.apiCall(apiUrl, 'GET')
      .subscribe((response: any) => {
        // console.log('Filter API Response:', response);
        if (response && response.Data) {
          if (forceUpdate || !this.gridData || this.gridData.length === 0) {
            this.gridData = response.Data.Items || [];
            
            this.totalPages = response.Data.TotalPages || 1;
            if (this.totalPages === 0 && response.Data.TotalItems) {
              this.totalPages = Math.ceil(response.Data.TotalItems / size);
            }
            
            this.currentPage = validPage;
            
         
          }
        } else {
          console.error('Invalid API response structure with filters:', response);
        }
      }, (error) => {
        console.error('Filter API call failed:', error);
      });
  }

  // Public method to completely clear all URL parameters
  public clearAllUrlParameters(): void {
    // Get the current route path without query parameters
    const currentPath = this.router.url.split('?')[0]; // Get URL without query parameters
    
    console.log('Clearing URL parameters. Current path:', currentPath);
    
    // Reset pagination first
    this.currentPage = 1;
    this.totalPages = 1;
    this.paginationPageSize = 10;
    this.gridOptions.paginationPageSize = 10;
    
    // Navigate to the same route but without query parameters
    this.router.navigate([currentPath], {
      queryParams: {},
      queryParamsHandling: 'replace' as any
    });
    
    // Call API directly without reading URL parameters
    console.log('Calling API after clearing parameters...');
    this.getApplicantDataAfterClear();
  }
  
  // Special method for API call after clearing parameters
  private getApplicantDataAfterClear(): void {
    const size = this.paginationPageSize;
    const validPage = 1;
    const start = 0; // Always start from 0 when clearing
    
    console.log('Clear API Debug:', {
      validPage: validPage,
      size: size,
      start: start,
      currentPage: this.currentPage
    });
    
    // Build API URL with default filter if configured
    let filterParam = '';
    if (this.gridPermissionByRole?.defaultFilter) {
      filterParam = `&filter=${encodeURIComponent(this.gridPermissionByRole.defaultFilter)}`;
    }
    const apiUrl = `${this.gridPermissionByRole.getApplicationListUrlEndPoint}?start=${start}&size=${size}&sortBy=CreatedOn&sortDir=desc${filterParam}`;
    console.log('Clear API URL:', apiUrl);
    
    this.api.apiCall(apiUrl, 'GET')
      .subscribe((response: any) => {
        // console.log('Clear API Response:', response);
        if (response && response.Data) {
          this.gridData = response.Data.Items || [];
          
          // Update pagination info
          this.totalPages = response.Data.TotalPages || 1;
          if (this.totalPages === 0 && response.Data.TotalItems) {
            this.totalPages = Math.ceil(response.Data.TotalItems / size);
          }
          
          this.currentPage = validPage;
          
          // console.log('Updated pagination state after clear:', {
          //   currentPage: this.currentPage,
          //   totalPages: this.totalPages,
          //   dataLength: this.gridData.length,
          //   totalItems: response.Data.TotalItems
          // });
        } else {
          console.error('Invalid API response structure after clear:', response);
        }
      }, (error) => {
        console.error('Clear API call failed:', error);
      });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gridPermissionByRole'] && this.gridPermissionByRole) {
      // Only auto-fetch if no gridData is provided from parent
      if (!this.gridData || this.gridData.length === 0) {
        this.currentPage = 1; // Reset to first page on initial load
        this.getApplicantData(this.currentPage, true);
      }
    }
  }

  public getApplicantData(page: number, forceUpdate: boolean = false) {
    // Use explicitly requested page and current page size to avoid stale URL timing
    const queryParams = this.route.snapshot.queryParams;
    const size = this.paginationPageSize;
    const validPage = Math.max(1, page);
    const start = (validPage - 1) * size; // Calculate the starting index for pagination
    
    // Update component state to match URL parameters
    this.currentPage = validPage;
    this.paginationPageSize = size;
    this.gridOptions.paginationPageSize = size;
    
    // Debug logging
    // console.log('Pagination Debug:', {
    //   originalPage: page,
    //   urlPage: urlPage,
    //   validPage: validPage,
    //   size: size,
    //   start: start,
    //   currentPage: this.currentPage,
    //   totalPages: this.totalPages,
    //   urlParams: { page: queryParams['page'], pageSize: queryParams['pageSize'] }
    // });
    

    

    // Get filter parameters from URL
    const filterParams = this.getFilterParamsFromUrl();
    const apiUrl = `${this.gridPermissionByRole.getApplicationListUrlEndPoint}?start=${start}&size=${size}&sortBy=CreatedOn&sortDir=desc${filterParams}`;
    // console.log('API URL with filters:', apiUrl);
    this.api.apiCall(apiUrl, 'GET')
      .subscribe((response: any) => {
        // console.log('API Response:', response);
        if (response && response.Data) {
          // Update data if forceUpdate is true OR if no parent-provided data exists
          if (forceUpdate || !this.gridData || this.gridData.length === 0) {
            this.gridData = response?.Data?.Items || response?.Data?.ItemsData || [];
            
            // Fix: Use TotalPages directly from API response, with fallback
            this.totalPages = response.Data.TotalPages || 1;
            
            // If TotalPages is 0 or undefined, calculate it from TotalItems
            if (this.totalPages === 0 && response.Data.TotalItems) {
              this.totalPages = Math.ceil(response.Data.TotalItems / size);
            }
            
            // Update current page to reflect the actual page we're on
            this.currentPage = validPage;
            
            // console.log('Updated pagination state:', {
            //   currentPage: this.currentPage,
            //   totalPages: this.totalPages,
            //   dataLength: this.gridData.length,
            //   totalItems: response.Data.TotalItems,
            //   responseTotalPages: response.Data.TotalPages
            // });
          }
        } else {
          console.error('Invalid API response structure:', response);
        }
      }, (error) => {
        console.error('API call failed:', error);
      });
  }








  // Profile pic cell renderer method
  profilePicCellRenderer = (params: any): HTMLElement => {
    const cellElement = document.createElement('div');
    cellElement.style.display = 'flex';
    cellElement.style.justifyContent = 'center';
    cellElement.style.alignItems = 'center';
    
    if (params.value) {
      const img = document.createElement('img');
      img.src = params.value;
      img.alt = 'Profile Pic';
      img.style.width = '50px';
      img.style.height = '33px';
      img.style.borderRadius = '50%';
      img.style.cursor = 'pointer';
      img.style.objectFit = 'cover';
      img.style.border = '1px solid #ddd';
      img.style.marginTop = '-8px';
      
      // Add hover events for image preview
      img.addEventListener('mouseenter', (event: MouseEvent) => {
        // Clear any existing hide timeout
        if (this.hidePreviewTimeout) {
          clearTimeout(this.hidePreviewTimeout);
          this.hidePreviewTimeout = null;
        }
        
        // Store current image element
        this.currentImageElement = img;
        
        this.showImagePreview(event, params.value);
      });
      
      img.addEventListener('mouseleave', (event: MouseEvent) => {
        // Add delay before hiding to prevent flickering
        this.hidePreviewTimeout = setTimeout(() => {
          this.hideImagePreview();
        }, 200);
      });
      
      // Also add mouseout event as backup
      img.addEventListener('mouseout', (event: MouseEvent) => {
        // Check if mouse is actually leaving the image
        if (!img.contains(event.relatedTarget as Node)) {
          this.hidePreviewTimeout = setTimeout(() => {
            this.hideImagePreview();
          }, 200);
        }
      });
      
      cellElement.appendChild(img);
    } else {
      const span = document.createElement('span');
      span.textContent = 'No Image';
      span.style.color = '#6c757d';
      span.style.fontSize = '0.875rem';
      cellElement.appendChild(span);
    }
    
    return cellElement;
  }

  private defaultColumnDefs: ColDef[] = [
    { headerName: 'Name', field: 'Name',flex: 1, minWidth: 120, sortable: true, filter: true, cellRenderer: this.navigateToPreview.bind(this) },
    { headerName: 'Application Type', field: 'ApplicationType', sortable: true, filter: true },
    { headerName: 'Profile Pic', field: 'ProfilePic', cellRenderer: this.profilePicCellRenderer, sortable: false, filter: false },
    { headerName: 'Mobile No', field: 'MobileNo', sortable: true, filter: true },
    { headerName: 'Email', field: 'Email', sortable: true, filter: true },
    { field: "Status", headerName: "Status", resizable: false, unSortIcon: true, cellRenderer: this.isApproveModalaOpen.bind(this), suppressMovable: true },
    { colId: 'action', field: "", headerName: "Action", resizable: false, unSortIcon: false, filter: false, cellRenderer: this.actionButtonFunction.bind(this), width: 200, headerClass: 'center-column-header', suppressMovable: true, pinned: 'right' },
  ];

  get displayedColumnDefs(): ColDef[] {
    const base = (this.columnDefs && this.columnDefs.length > 0) ? [...this.columnDefs] : [...this.defaultColumnDefs];
    const withoutAction = base.filter(col => (col as any).colId !== 'action' && col.headerName !== 'Action');
    const hasAction = base.length !== withoutAction.length;
    if (this.showActionColumn) {
      // Include action column once
      return hasAction ? base : [...withoutAction, this.getActionColumnDef()];
    }
    // Explicitly hide action column
    return withoutAction;
  }

  private getActionColumnDef(): ColDef {
    return { colId: 'action', field: "", headerName: "Action", resizable: false, unSortIcon: false, filter: false, cellRenderer: this.actionButtonFunction.bind(this), width: 200, headerClass: 'center-column-header', suppressMovable: true, pinned: 'right' };
  }

  // Child function for creating the Approve button
  approveButtonFunction(params: any): HTMLElement | null {

    if (!this.gridPermissionByRole.isApprovalPermission) {
      return null; // This works now because we allow null
    }

    const approveButton = document.createElement('a');
    approveButton.innerHTML = '✅';
    approveButton.classList.add('custom-green-button-Approve');
    approveButton.title = 'Approve';
    approveButton.addEventListener('click', () => {

      this.OpenApproveModal(params.node.data);
    });
    return approveButton;
  }

  // Child function for creating the Reject button
  rejectButtonFunction(params: any): HTMLElement | null {


    if (!this.gridPermissionByRole.isRejectPermission) {
      return null; // This works now because we allow null
    }

    const rejectButton = document.createElement('a');
    rejectButton.innerHTML = '❌';
    rejectButton.classList.add('custom-red-button-reject');
    rejectButton.title = 'Reject';
    rejectButton.addEventListener('click', () => {
      this.OpenRejectionModal(params.node.data);
    });
    return rejectButton;
  }


  editAppCocAocrmappingButtonFunction(params: any): HTMLElement | null {
    // 👇 check permission (similar to reject)
    if (!this.gridPermissionByRole.isEditPermission) {
      return null; // return nothing if no edit permission
    }
  
    const editButton = document.createElement('a');
    editButton.innerHTML = '<img src="assets/images/edit-icon.png" width="16" height="16" title="Edit APP COC AOC Mapping">'; // or use <i class="fa fa-edit"></i> if you use FontAwesome
    editButton.classList.add('custom-blue-button-edit');
    editButton.title = 'Edit App Coc Aoc Mapping';
  
    editButton.addEventListener('click', () => {
      this.OpeneditAppCocAocrmappingButtonFunctionModal(params.node.data); 
      // 👆 call your edit function with row data
    });
  
    return editButton;
  }



  // Child function for creating the FirstAid button
  sendToFirstAidButton(params: any): HTMLElement | null {

    if (!this.gridPermissionByRole.isSendToFirstAidPermission) {
      return null; // This works now because we allow null
    }

    const sendToFirstAidButton = document.createElement('a');
    sendToFirstAidButton.innerHTML = '🩺';
    sendToFirstAidButton.classList.add('custom-red-button-reject');
    sendToFirstAidButton.title = 'Send To FirstAid';
    sendToFirstAidButton.addEventListener('click', () => {

      this.OpenSendToFirstAidModal(params.node.data);
    });
    return sendToFirstAidButton;
  }

  // Child function for creating the Add Notes button
  addNotesButtonFunction(params: any): HTMLElement | null {

    if (!this.gridPermissionByRole.isAddNotesAddPermission) {
      return null; // This works now because we allow null
    }


    const addNotesButton = document.createElement('a');
    addNotesButton.innerHTML = '<img src="assets/images/channel-add-icon.png" width="24" height="24">';
    addNotesButton.classList.add('custom-icon-btn');
    addNotesButton.title = 'Add Notes';
    addNotesButton.addEventListener('click', () => {

      this.OpenAddNotesModal(params.node.data);
    });
    return addNotesButton;
  }

  // Child function for creating the Send Back to Applicant button
  sendBackToApplicantButtonFunction(params: any): HTMLElement | null {
    if (!this.gridPermissionByRole.isSendBackToApplicantPermission) {
      return null;
    }

    const sendBackButton = document.createElement('a');
    sendBackButton.innerHTML = '↩️';
    sendBackButton.classList.add('custom-orange-button-sendback');
    sendBackButton.title = 'Send Back to Applicant';
    sendBackButton.addEventListener('click', () => {
      this.OpenSendBackToApplicantModal(params.node.data);
    });
    return sendBackButton;
  }

  // Child function for creating the Forward to GAO button
  forwardToGAOButtonFunction(params: any): HTMLElement | null {
    if (!this.gridPermissionByRole.isForwardToGAOPermission) {
      return null;
    }

    const forwardButton = document.createElement('a');
    forwardButton.innerHTML = '➡️';
    forwardButton.classList.add('custom-blue-button-forward');
    forwardButton.title = 'Forward to GAO';
    forwardButton.addEventListener('click', () => {
      this.OpenForwardToGAOModal(params.node.data);
    });
    return forwardButton;
  }

  // Child function for creating the GAO Send Back to APP button
  gaoSendBackToAPPButtonFunction(params: any): HTMLElement | null {
    if (!this.gridPermissionByRole.isGaoSendBackToAPP) {
      return null;
    }

    const gaoSendBackButton = document.createElement('a');
    gaoSendBackButton.innerHTML = '↩️';
    gaoSendBackButton.classList.add('custom-orange-button-gao-sendback');
    gaoSendBackButton.title = 'GAO Send Back to APP';
    gaoSendBackButton.addEventListener('click', () => {
      this.OpenGaoSendBackToAPPModal(params.node.data);
    });
    return gaoSendBackButton;
  }

  // Child function for creating the Resolve by First Aid button
  resolveByFirstAidButtonFunction(params: any): HTMLElement | null {


    if (!this.gridPermissionByRole.isFirstAidResolvePermission) {
      return null; // This works now because we allow null
    }


    const resolveButton = document.createElement('a');
    resolveButton.innerHTML = '🔄';
    resolveButton.classList.add('custom-red-button-reject'); // Add CSS for this button
    resolveButton.title = 'Resolve by FirstAid';
    resolveButton.addEventListener('click', () => {
   
      this.OpenResolveByFirstAidModal(params.node.data);
    });
    return resolveButton;
  }

  // Parent function to assemble buttons
  // Parent function to assemble buttons
  actionButtonFunction(params: any): HTMLElement {
    const cellElement = document.createElement('div');
    cellElement.classList.add('center-column');

    // Conditionally append child buttons if they are not null
    const approveButton = this.approveButtonFunction(params);
    if (approveButton) {
      cellElement.appendChild(approveButton);
    }

    const rejectButton = this.rejectButtonFunction(params);
    if (rejectButton) {
      cellElement.appendChild(rejectButton);
    }

    const editAppCocAocrmappingButton = this.editAppCocAocrmappingButtonFunction(params);
    if (editAppCocAocrmappingButton) {
      cellElement.appendChild(editAppCocAocrmappingButton);
    }


    



    const resolveButton = this.resolveByFirstAidButtonFunction(params);
    if (resolveButton) {
      cellElement.appendChild(resolveButton);
    }

    const firstAidButton = this.sendToFirstAidButton(params);
    if (firstAidButton) {
      cellElement.appendChild(firstAidButton);
    }

    const addNotesButton = this.addNotesButtonFunction(params);
    if (addNotesButton) {
      cellElement.appendChild(addNotesButton);
    }

    const sendBackButton = this.sendBackToApplicantButtonFunction(params);
    if (sendBackButton) {
      cellElement.appendChild(sendBackButton);
    }

    const forwardButton = this.forwardToGAOButtonFunction(params);
    if (forwardButton) {
      cellElement.appendChild(forwardButton);
    }

    const gaoSendBackButton = this.gaoSendBackToAPPButtonFunction(params);
    if (gaoSendBackButton) {
      cellElement.appendChild(gaoSendBackButton);
    }


   


    return cellElement;
  }


  navigateToPreview(params: any) {
    const link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.innerText = params.data.Name;
    link.addEventListener('click', () => {
      this.router.navigate([this.gridPermissionByRole.previewRoutePath], { state: { rowData: params.node.data, NotesCreatoTypeId:this.gridPermissionByRole.noteCreatorId } });
    });
    return link;
  }

  isApproveModalaOpen(params: any) {
    if (params.data.ApplicationState == "Incomplete") {
      return `<div class="custom-status pending">${params.data.ApplicationState}</div>`;
    }
    else if (params.data.ApplicationState == "Rejected") {
      return `<div class="custom-status blocked">${params.data.ApplicationState}</div>`;
    }
    else {
      return `<div class="custom-status onboarded ">${params.data.ApplicationState}</div>`;
    }

  }


  customActionCellRenderer(params: any) {
    const cellElement = document.createElement('div');
    cellElement.classList.add('center-column');
    const button = document.createElement('a');
    button.innerHTML = '🗑️';
    button.classList.add('action-icon', 'custom-icon-btn');
    button.title = 'Delete';
    button.addEventListener('click', () => {
      // Perform your action
      this.showFun(params);
    });
    cellElement.appendChild(button);
    return cellElement;
  }

  showFun(arg: any) {

  }

  // Pagination methods
  goToFirstPage(): void {
    console.log('goToFirstPage called, currentPage:', this.currentPage, 'totalPages:', this.totalPages);
    if (this.currentPage !== 1) {
      this.currentPage = 1;
      this.updateUrlWithPage(this.currentPage);
      this.getApplicantData(this.currentPage, true);
    }
  }

  goToPreviousPage(): void {
    console.log('goToPreviousPage called, currentPage:', this.currentPage, 'totalPages:', this.totalPages);
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateUrlWithPage(this.currentPage);
      this.getApplicantData(this.currentPage, true);
    }
  }

  goToNextPage(): void {
    console.log('goToNextPage called, currentPage:', this.currentPage, 'totalPages:', this.totalPages);
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateUrlWithPage(this.currentPage);
      this.getApplicantData(this.currentPage, true);
    } else {
      console.log('Cannot go to next page - already at last page');
    }
  }

  goToLastPage(): void {
    console.log('goToLastPage called, currentPage:', this.currentPage, 'totalPages:', this.totalPages);
    if (this.currentPage !== this.totalPages) {
      this.currentPage = this.totalPages;
      this.updateUrlWithPage(this.currentPage);
      this.getApplicantData(this.currentPage, true);
    }
  }

  // Helper method to update URL with current page
  private updateUrlWithPage(page: number): void {
    const queryParams = { ...this.route.snapshot.queryParams };
    queryParams['page'] = page.toString();
    
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }

  onGridReady(params: any): void {
    params.api.sizeColumnsToFit();
    // Auto resize to fit screen
  }

  onPageSizeChange(): void {
    // Reset to the first page whenever the page size changes
    this.currentPage = 1;
    this.gridOptions.paginationPageSize = this.paginationPageSize;
    
    // Update URL with new page size and reset to page 1
    const queryParams = { ...this.route.snapshot.queryParams };
    queryParams['page'] = '1';
    queryParams['pageSize'] = this.paginationPageSize.toString();
    
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
    
    this.getApplicantData(this.currentPage, true);
  }

  OpenApproveModal(applicantData: any) {

    const dialogRef = this.dialogService.open<any>(ConfirmApprovalModalComponent, {
      context: {
        data: {
          requestBody: {
            // "CompletionPercentage": 0,
            // "IsActive": true,
            // "Id": 0,

            "ApplicationGuid": applicantData.ApplicationGuid,
            "SevaProfileDisplayUID": applicantData.SevaProfileDisplayUID,
            "FinalRemarks": "",
            "IsApproved": true
          },
          endPoint: 'GAO/Finalize',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });
    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.toastr.success('Application Approved Successfully');
        this.getApplicantData(this.currentPage, true); // Handle approval
        // this.FormApproveSucessfully()
        // this.getAllApplication();  // Handle approval
      } else {

      }
    });
  }

  OpenRejectionModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ConfirmRejectionModalComponent, {
      context: {
        data: {
          requestBody: {
            // "CompletionPercentage": 0,
            // "IsActive": true,
            // "Id": 0,
            "ApplicationGuid": applicantData.ApplicationGuid,
            "SevaProfileDisplayUID": applicantData.SevaProfileDisplayUID,
            "FinalRemarks": "",
            "IsApproved": false
          },
          endPoint: 'GAO/Finalize',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        // this.getAllApplication();  // Handle approval

        this.toastr.error('Application Rejected Successfully');
        this.getApplicantData(this.currentPage, true);

        // this.FormRejectSucessfully();
      } else {

      }
    });
  }

  OpenAddNotesModal(applicantData: any) {
    const dialogRef = this.dialogService.open(AddNotesModalComponent, {
      context: {
        data: {
          requestBody: {
            "ApplicationGuid": applicantData.ApplicationGuid,
            "SubmittedOn": new Date().toISOString(),
            "SubmittedBy": "string",
            "Notes": "string",
            "NotesCreatoTypeId": this.gridPermissionByRole.noteCreatorId
          },
          endPoint: 'Applicant/aaplication/AddNote',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        // this.getAllApplication();  // Handle approval
        // this.NotesAddedSucesfulModal();
        this.toastr.success('Note Added Successfully');
        this.getApplicantData(this.currentPage, true)
      } else {

      }
    });
  }


  OpeneditAppCocAocrmappingButtonFunctionModal(applicantData: any) {
    const dialogRef = this.dialogService.open(AppAocCocMappingModalComponent, {
      context: {
        data: {
          requestBody: {
            CenterId: applicantData.Id,
            "CenterName": applicantData.CenterName,
            "APPId": applicantData.APPId,
            "COCId":applicantData.COCId,
            "AOCId": applicantData.AOCId,
            "ApplicationGuid": applicantData.ApplicationGuid,
          },
          endPoint: 'Center/UpdateAdminCenterAPPCOCAOCAsync',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.toastr.success('Application Approved Successfully');
        this.getApplicantData(this.currentPage, true); // Handle approval

        // this.getAllApplication();  // Handle approval
        // this.FormApproveSucessfully();
      } else {

      }
    });
  }

  OpenSendToFirstAidModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ConfirmSendToFirstAidModalComponent, {
      context: {
        data: {
          requestBody: {
            "TaggedForFirstNotes": "string",
            "TaggedForFirstAidBy": "string",
            "ApplicationGuid": applicantData.ApplicationGuid,
          },
          endPoint: 'GAO/sendToFirstAid',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.toastr.success('Application Approved Successfully');
        this.getApplicantData(this.currentPage, true); // Handle approval


        // this.getAllApplication();  // Handle approval
        // this.FormApproveSucessfully();
      } else {

      }
    });
  }

  OpenResolveByFirstAidModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ResolvedByFirstAidModalComponent, {
      context: {
        data: {
          requestBody: {

            "ApplicationGuid": applicantData.ApplicationGuid,
            "HasFirstAidResolved": true,
            "FirstAidResolvedOn": new Date().toISOString(),
            "FirstAidResolvedBy": "string",
            "FirstAidNotes": ""
          },
          endPoint: 'FirstAid/resolve-application',
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.toastr.success('Application Approved Successfully');
        this.getApplicantData(this.currentPage, true); // Handle approval

        // this.getAllApplication();  // Handle approval
        // this.FormApproveSucessfully();
      } else {

      }
    });
  }

  OpenSendBackToApplicantModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ConfirmSendBackToApplicantModalComponent, {
      context: {
        data: {
          requestBody: {
            "ApplicationGuid": applicantData.ApplicationGuid,
            "Comment": ""
          },
          endPoint: this.gridPermissionByRole.sendBackToApplicantUrl,
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        this.toastr.success('Application sent back to applicant successfully');
        this.getApplicantData(this.currentPage, true);
      }
    });
  }

  OpenForwardToGAOModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ConfirmForwardToGAOModalComponent, {
      context: {
        data: {
          requestBody: {
            "ApplicationGuid": applicantData.ApplicationGuid,
            "Comment": ""
          },
          endPoint: this.gridPermissionByRole.forwardToGAOP,
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        this.toastr.success('Application forwarded to GAO successfully');
        this.getApplicantData(this.currentPage, true);
      }
    });
  }

  OpenGaoSendBackToAPPModal(applicantData: any) {
    const dialogRef = this.dialogService.open(ConfirmSendBackToApplicantModalComponent, {
      context: {
        data: {
          requestBody: {
            "ApplicationGuid": applicantData.ApplicationGuid,
            "Comment": ""
          },
          endPoint: this.gridPermissionByRole.gaoSendBackToAPPUrl,
        },
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {
      if (res === true) {
        this.toastr.success('Application sent back to APP successfully');
        this.getApplicantData(this.currentPage, true);
      }
    });
  }


  // NotesAddedSucesfulModalComponent


  // NotesAddedSucesfulModal() {

  //   const dialogRef = this.dialogService.open(NotesAddedSucesfulModalComponent, {
  //     context: {
  //       data: {
  //         'name': 'Chetan',
  //         'city': "Malegaon",
          
  //       }
  //     },
  //     closeOnBackdropClick: false,
  //     hasScroll: true,
  //   });

  //   dialogRef.onClose.subscribe(res => {

  //     if (res === true) {
  //       // this.getAllApplication(); 
  //       this.getApplicantData(this.currentPage, true); // Handle approval
  //     } else {

  //     }
  //   });

  // }


  // FormApproveSucessfully() {

  //   const dialogRef = this.dialogService.open(FormApprovalSuccessModalComponent, {
  //     context: {
  //       data: {
  //         'name': 'Chetan',
  //         'city': "Malegaon",
          
  //       }
  //     },
  //     closeOnBackdropClick: false,
  //     hasScroll: true,
  //   });

  //   dialogRef.onClose.subscribe(res => {

  //     if (res === true) {
  //       // this.getAllApplication(); 
  //       this.getApplicantData(this.currentPage, true); // Handle approval
  //     } else {

  //     }
  //   });

  // }

  // FormRejectSucessfully() {

  //   const dialogRef = this.dialogService.open(FormRejectionSuccessModalComponent, {
  //     context: {
  //       data: {
  //         'name': 'Chetan',
  //         'city': "Malegaon",
  //       }
  //     },
  //     closeOnBackdropClick: false,
  //     hasScroll: true,
  //   });

  //   dialogRef.onClose.subscribe(res => {

  //     if (res === true) {
  //       // this.getAllApplication();  // Handle approval
  //       this.toastr.success('Application Approved Successfully');
  //       this.getApplicantData(this.currentPage, true);
  //     } else {

  //     }
  //   });

  // }

  exportToCSV(): void {
    // Prepare the headers
    const exportColumns = this.displayedColumnDefs.filter((col) => (col as any).colId !== 'action' && col.headerName !== 'Action');
    const headers = exportColumns.map((col) => col.headerName);

    // Map grid data to CSV format
    const rows = this.gridData.map((row) =>
      exportColumns.map((col) => row[col.field || ''])
    );

    // Create CSV content
    const csvContent = [headers, ...rows]
      .map((row) => row.join(','))
      .join('\n');

    // Create a Blob and download it
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'InProcessApplicants.csv';
    link.click();
  }

  // Image preview methods
  showImagePreview(event: MouseEvent, imageUrl: string): void {
    this.previewImageUrl = imageUrl;
    
    // Calculate position with viewport boundaries
    const previewWidth = 300; // Max width from CSS
    const previewHeight = 300; // Max height from CSS
    const offset = 10;
    
    let x = event.clientX + offset;
    let y = event.clientY + offset;
    
    // Check if preview would go outside right edge
    if (x + previewWidth > window.innerWidth) {
      x = event.clientX - previewWidth - offset;
    }
    
    // Check if preview would go outside bottom edge
    if (y + previewHeight > window.innerHeight) {
      y = event.clientY - previewHeight - offset;
    }
    
    // Ensure preview doesn't go outside left edge
    if (x < 0) {
      x = offset;
    }
    
    // Ensure preview doesn't go outside top edge
    if (y < 0) {
      y = offset;
    }
    
    this.previewPosition = { x, y };
    this.showPreview = true;
    
    // Force change detection
    this.cd.detectChanges();
  }

  hideImagePreview(): void {
    // Clear any existing hide timeout
    if (this.hidePreviewTimeout) {
      clearTimeout(this.hidePreviewTimeout);
      this.hidePreviewTimeout = null;
    }
    
    this.showPreview = false;
    this.currentImageElement = null;
    
    // Force change detection
    this.cd.detectChanges();
  }

  // Handle mouse enter on preview popup
  onPreviewMouseEnter(): void {
    // Clear any existing hide timeout when mouse enters preview
    if (this.hidePreviewTimeout) {
      clearTimeout(this.hidePreviewTimeout);
      this.hidePreviewTimeout = null;
    }
  }

  // Handle mouse leave on preview popup
  onPreviewMouseLeave(): void {
    // Add delay before hiding when mouse leaves preview
    this.hidePreviewTimeout = setTimeout(() => {
      this.hideImagePreview();
    }, 300); // 300ms delay
  }


  ngOnDestroy(): void {
    // Remove the global mouse move listener
    if (this.mouseMoveListener) {
      document.removeEventListener('mousemove', this.mouseMoveListener);
    }
    
    // Clear any pending timeouts
    if (this.hidePreviewTimeout) {
      clearTimeout(this.hidePreviewTimeout);
    }
  }

}
